
<app-page-loader></app-page-loader>
<router-outlet></router-outlet>